import * as React from "react";
import styled, { css } from "styled-components";
import { Alert } from "components/bootstrap";
import { Link } from "components/common";
import Routes from "routing/Routes";
const Reasons = styled.ul(
  ({ theme }) => css`
    list-style: disc;
    margin: ${theme.spacings.xs} 0 ${theme.spacings.sm};
    padding-left: ${theme.spacings.lg};

    li {
      margin-bottom: ${theme.spacings.xxs};
    }
  `
);
const DataLakeStreamDeleteWarning = ({ streamId, isEnabled, hasArchivedData, hasRetrievals }) => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "This stream cannot be deleted yet" }, /* @__PURE__ */ React.createElement(Reasons, null, isEnabled && /* @__PURE__ */ React.createElement("li", null, "Data Lake routing is enabled on this stream."), hasArchivedData && /* @__PURE__ */ React.createElement("li", null, "The stream has data in the Data Lake."), hasRetrievals && /* @__PURE__ */ React.createElement("li", null, "Data Lake retrievals exist for this stream. Their messages become unsearchable once the stream is gone.")), /* @__PURE__ */ React.createElement("p", null, "Resolve this in the", " ", /* @__PURE__ */ React.createElement(Link, { to: `${Routes.stream_view(streamId)}?segment=destinations` }, "Data Lake destination of this stream"), " ", "before deleting it."));
export default DataLakeStreamDeleteWarning;
